// src/pages/Reports/CurrentAssetLedger/currentAssetLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchCurrentAssetLedger } from "./currentAssetLedgerThunk";

const initialState = {
  list: [],
  opening_balance: 0,
  closing_balance: 0,
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const currentAssetLedgerSlice = createSlice({
  name: "currentAssetLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentAssetLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCurrentAssetLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.opening_balance = action.payload.opening_balance;
        state.closing_balance = action.payload.closing_balance;
      })
      .addCase(fetchCurrentAssetLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = currentAssetLedgerSlice.actions;
export default currentAssetLedgerSlice.reducer;
